module.exports = __webpack_public_path__ + "static/img/gaokao.c609081.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gaokao.png
// module id = eHAe
// module chunks = 1